import { isAndroid, isIos } from "./utils";
const AppId = "cjs";
const AppSecret = "5%20qIhKFRPOH6uk08qnhTUJA9bZsPsz";

const AppVersion = "v1.0.0";

const GetDeviceType = () => {
  if (isIos()) return "iOS";
  if (isAndroid()) return "Android";
  return "web";
};

export {GetDeviceType, AppId, AppSecret, AppVersion };
